var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-slider__button",class:`hero-slider__${_vm.params.suffix}`},[_c('Icon',{staticClass:"hero-slider__button-svg",attrs:{"viewport":"0 0 25 18","xlink":`arrow-slider-${_vm.params.suffix}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }